module.exports = __webpack_public_path__ + "img/borderShieldWhite.9db7edda.svg";